import {useUserStore} from "../../../../../../../modules/shop/user/store";
import {formatDate, formatTime} from "../../../../../../shared/functions/formateDate";
import {useEffect, useState} from "react";
import {useTransfersStore} from "../../../../../../../modules/profile/transfers/store";
import Pagination from "../../../../../../shared/Pagination/Pagination";

// Історія переказів: вхідні зелені зі стрілкою вниз, вихідні — сірі зі стрілкою вгору
const TransfersList = () => {
    const user = useUserStore(state => state.user)
    const transfers = useTransfersStore(state => state.transfers)
    const fetchTransfers = useTransfersStore(state => state.fetchTransfers)
    const totalItems = useTransfersStore(state => state.totalItems)
    const [activePage, setActivePage] = useState(1);

    useEffect(() => {
        fetchTransfers(activePage)
    }, [activePage])

    return (
        <div className="bc-list-card">
            <h4 className="bc-list-title">Історія переказів</h4>
            { transfers.length === 0
                ? <div className="bc-empty">Переказів ще не було</div>
                : <div className="tr-list">
                    { transfers.map((t) => {
                        const incoming = user.steamId === t.recipient
                        return (
                            <div key={t._id} className={`tr-row ${incoming ? "tr-in" : "tr-out"}`}>
                                <span className="tr-dir" aria-hidden="true">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                        { incoming ? <path d="M12 5v14M6 13l6 6 6-6" /> : <path d="M12 19V5M6 11l6-6 6 6" /> }
                                    </svg>
                                </span>
                                <div className="tr-main">
                                    <span className="tr-who">{incoming ? "Від" : "Кому"} <b>{incoming ? t.sender : t.recipient}</b></span>
                                    <span className="tr-date">{formatDate(t.date)} · {formatTime(t.date)}</span>
                                </div>
                                <span className="tr-amount">{incoming ? "+" : "−"}{t.amount} ₴</span>
                            </div>
                        )
                    })}
                </div>
            }
            { totalItems > 6 && <Pagination totalItems={totalItems} active={activePage} setActive={setActivePage} /> }
        </div>
    );
};

export default TransfersList;
